<template>
  <v-autocomplete
    v-model="select"
    :loading="isLoading"
    :items="pickings"
    :search-input.sync="search"
    color="secondary"
    label="Search by Picking Name/Number:"
    :item-text="createSelectLabel"
    :item-value="createSelectLabel"
    :return-object="true"
    box
    cache-items
    full-width
    hide-details
    large
    prepend-inner-icon="search"
    hide-no-data
  ></v-autocomplete>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "PickingSearch",
  props: {
    defaultPicking: Object
  },
  data() {
    return {
      select: null,
      search: null,
      timeout: null
    };
  },

  computed: {
    ...mapGetters({
      isLoading: "app/isLoading",
      pickings: "picking/getPickings"
    })
  },
  mounted() {
    if (this.defaultPicking) {
      this.pickingSearch([
        {
          field: "name",
          operator: "ilike",
          value: this.defaultPicking.name
        },
        {
          field: "name",
          operator: "ilike",
          value: "out"
        }
      ]);
      this.select = this.createSelectLabel(this.defaultPicking);
    }
  },
  methods: {
    ...mapActions({
      pickingSearch: "picking/search"
    }),

    createSelectLabel(e) {
      return e.name;
    }
  },

  watch: {
    select(picking) {
      this.$emit("picking-selected", picking);
    },

    search(value) {
      clearTimeout(this.timeout);
      if (value && value !== "" && value.length > 2) {
        let self = this;
        self.timeout = setTimeout(() => {
          self.pickingSearch([
            {
              field: "name",
              operator: "ilike",
              value: value
            },
            {
              field: "name",
              operator: "ilike",
              value: "out"
            }
          ]);
        }, 1000);
      }
    }
  }
};
</script>